const fmt = (n) => `$${Number(n || 0).toFixed(2)}`;

// One line per cashout: cash paid · credits returned · fee retained · still owed (server-computed).
export const CashoutBreakdown = ({ b, testId }) => {
    if (!b) return null;
    return (
        <div className="text-[10px] font-mono text-[#A0AAB2] mt-1 flex flex-wrap gap-x-2 justify-end" data-testid={testId}>
            <span>cash paid <span className="text-sky-300" data-testid={`${testId}-cash`}>{fmt(b.cash_paid)}</span></span>
            <span>· credits back <span className="text-violet-300" data-testid={`${testId}-credits`}>{fmt(b.credits_returned)}</span></span>
            <span>· fee kept <span className="text-white" data-testid={`${testId}-fee`}
                title={b.fee_retained == null ? 'Recorded on the old gross basis — the record cannot show whether the fee was withheld' : undefined}>
                {b.fee_retained == null ? 'unknown' : fmt(b.fee_retained)}</span></span>
            {b.still_owed !== undefined && <span>· still owed <span className="text-amber-300" data-testid={`${testId}-owed`}>{fmt(b.still_owed)}</span></span>}
            {b.paid_above_net > 0 && <span className="text-[#FF007F]" data-testid={`${testId}-above-net`}>· legacy row: recorded {fmt(b.paid_above_net)} above net (old gross basis)</span>}
        </div>
    );
};
